import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useMediaScreenshot } from "../../../../hooks";
import { usePrevious } from '@isyc-react/core';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import '@isyc-react/design/main';
import "../../camera.style.scss";
export const CameraPhotoButton = props => {
  const {
    source,
    stream,
    onPhoto,
    options
  } = props;
  const [capturer, {
    screenshot
  }] = useMediaScreenshot(source, stream);
  const previous = usePrevious(screenshot);
  React.useEffect(() => {
    if (onPhoto && screenshot && screenshot !== previous) onPhoto(screenshot);
  }, [screenshot, onPhoto]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, capturer && /*#__PURE__*/React.createElement(RippleButton, {
    onClick: () => capturer.capture(options),
    className: "btn-media-camera action"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera"
  })));
};